import { faPlus, faTrashAlt, faUser } from '@fortawesome/free-solid-svg-icons'

export const createActionButtonsHandler = (
  waitingCustomerId: number,
  calendarUrl: string,
  onDeleteClick: any,
) => [
  {
    icon: faUser,
    name: 'View customer',
    callback: () => {
      window.location.replace(`/customers/${waitingCustomerId}`)
    },
  },
  {
    icon: faPlus,
    name: 'Add to calendar',
    callback: () => window.location.replace(calendarUrl),
  },
  {
    icon: faTrashAlt,
    name: 'Delete',
    callback: onDeleteClick,
    style: 'destructive',
  },
]
